import { retrieveServerTime } from '@goldcast/api/backend';

import { getEnv } from '@/constants';

export async function getServerTime() {
  const data = await retrieveServerTime({});
  return {
    statusCode: 200,
    statusText: 'OK',
    data
  };
}

export function getTimekeeperTime() {
  return fetch(getEnv('TIME_SYNC_SERVER'));
}
